import { useMutation, useQuery } from "react-query";

import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";

const PASSWORDS = "/password";

const postCreatePasswordToken = (payload) => api.post(PASSWORDS, payload);
export const usePostCreatePassword = () => {
  const { addSnackbarSuccess } = useHubSnackBar();

  return useMutation(postCreatePasswordToken, {
    onSuccess: () => {
      addSnackbarSuccess({
        title: "Password Reset",
        message: "Password reset link sent to email if associated",
      });
    },
  });
};

const putCreatePasswordToken = ({ token, password }) =>
  api.put(`${PASSWORDS}/${token}`, { password });
export const usePutCreatePassword = () => {
  const { addSnackbarSuccess } = useHubSnackBar();

  return useMutation(putCreatePasswordToken, {
    onSuccess: () => {
      addSnackbarSuccess({
        message: "Password Successfully Reset",
      });
    },
  });
};

const getPasswordTokenById = ({ queryKey }) =>
  api.get(`${PASSWORDS}/${queryKey[1]}`);
export const useGetPasswordTokenById = (id) => {
  return useQuery([PASSWORDS, id], getPasswordTokenById, {
    enabled: !!id,
  });
};
